import React from 'react';
import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { createRouteRef } from '@backstage/core-plugin-api';
import { compatWrapper } from '@backstage/core-compat-api';

export const catalogSyncRouteRef = createRouteRef({ id: 'catalog-sync-page' });

const catalogSyncPage = PageBlueprint.make({
  name: 'catalog-sync-page',
  params: {
    path: '/catalog-sync',
    routeRef: catalogSyncRouteRef,
    loader: async () =>
      import('./components/SyncPage').then(m =>
        import('./components/DevopsGuard').then(g =>
          compatWrapper(
            React.createElement(
              g.DevopsGuard,
              null,
              React.createElement(m.SyncPage),
            ),
          ),
        ),
      ),
  },
});

const catalogSyncPagePlugin = createFrontendPlugin({
  pluginId: 'catalog-sync-page',
  extensions: [catalogSyncPage],
  routes: {
    root: catalogSyncRouteRef,
  },
});

export default catalogSyncPagePlugin;
